






































































































































import { Component, Vue } from 'vue-property-decorator';
import { BookingWizardModule } from '@/store/modules/bookingWizard';
import BookingRoleViewModel from '@/models/BookingRoles/BookingRoleViewModel'
import ShiftViewModel from '@/models/Shifts/ShiftViewModel';
import DateTimeUtils from '@/lib/dateTimeUtils';
import CurrencyUtils from '@/lib/currencyUtils';
import LocationDto from '@/models/Locations/LocationDto';
import BranchDto from '@/models/Branches/BranchDto';
import DepartmentDto from '@/models/Departments/DepartmentDto';
import GiganautVue from '@/components/Shared/GiganautVue';

@Component({
  name: 'BookingWizardReview',
  components: {  }
})
export default class BookingWizardReview extends GiganautVue {

    get dates() {
        return BookingWizardModule.newBooking.dates;
    }

    get datesSummary() {
        let dates = "";
        for (let i=0; i < BookingWizardModule.newBooking.dates.length; i++) {
            if (i !== 0) {
                dates += ", ";
            }
            dates += DateTimeUtils.toShortDate(new Date(BookingWizardModule.newBooking.dates[i]));
        }
        return dates;
    }

    get booking() {
        return BookingWizardModule.newBooking;
    }

    // get currentLocation() {
    //     //if (BookingWizardModule.newBooking.location == null) {
    //         //return new LocationDto();
    //     //} else {
    //         return BookingWizardModule.newBooking.location;
    //     //}
    // }

    // get currentBranch() {
    //     //if (BookingWizardModule.newBooking.branch == null) {
    //         //return new BranchDto();
    //     //} else {
    //         return BookingWizardModule.newBooking.branch;
    //     //}
    // }

    // get currentDepartment() {
    //     //if (BookingWizardModule.newBooking.department == null) {
    //         //return new DepartmentDto();
    //     //} else {
    //         return BookingWizardModule.newBooking.department;
    //     //}
    // }

    get currentStep() {
        return BookingWizardModule.newBooking.currentStep;
    }

    get roles() {
        return BookingWizardModule.newBooking.roles;
    }

    shiftLengthHours(startAtTime: string, endAtTime: string) {
        return DateTimeUtils.calculateShiftLength(startAtTime, endAtTime);
    }

    convertToCurrency(value: number) {
        return CurrencyUtils.convertToCurrency(value);
    }

    formatDate(date: Date) {
        return DateTimeUtils.toShortDate(date);
    }
}
